import styled from "@emotion/styled"
import { Container } from "@mui/material"
import { ImageContainer } from "./ImageContainer"
import { Desktop, Mobile } from "./common/bit/MediaQueries"

const StyledSideTextImage = styled.div<{ $isSwitched?: boolean }>`
  img {
    padding-top: 5px;
    padding-bottom: 5px;
  }
  ${(props) => props.theme.breakpoints.up("md")} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 70px;
    ${(p) => p.$isSwitched && "align-items: center"};
    img {
      padding-top: 0px;
      padding-bottom: 0px;
    }
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    gap: 82px;
  }
`

type SideImageText = {
  gap: number
  isSwitched: boolean
  children: JSX.Element
  image: string
  flip: boolean
}

function SideImageText({ gap, children, image, flip }: SideImageText) {
  return (
    <>
      <Desktop>
        <StyledSideTextImage $isSwitched={flip}>
          {!flip ? children : null}
          <ImageContainer
            desktopUrl={image}
            height={720}
            emptyAlt={true}
            mobileHeight={260}
            mediumHeight={475}
            sm
          />
          {flip ? children : null}
        </StyledSideTextImage>
      </Desktop>
      <Mobile>
        <Container>
          <StyledSideTextImage $isSwitched={flip}>
            {children}
            <ImageContainer
              emptyAlt={true}
              desktopUrl={image}
              height={720}
              mobileHeight={260}
              sm
            />
          </StyledSideTextImage>
        </Container>
      </Mobile>
    </>
  )
}

export default SideImageText
